import gql from 'graphql-tag';

export const DeleteAccidentIssue = gql`
  mutation DeleteAccidentIssueBulk($input: DeleteAccidentIssueBulkInput!) {
    deleteAccidentIssueBulk(input: $input) {
      deleted
    }
  }
`;
